import { Severity } from '@sentry/types';
import { captureMessage } from '@sentry/browser';
import * as rudderanalytics from 'rudder-sdk-js';

const WAIT_FOR_READY_TRIES_MAX = 20;
const WAIT_FOR_READY_TRIES_TIME = 200;

let isReady = null;


export interface RudderStackPluginOptions {
    writeKey: string;
    dataPlaneUrl: string;
}

const waitsRudderStackToBeReady = async () => {
    const checkIsReady = (
        resolve, tries = WAIT_FOR_READY_TRIES_MAX,
    ) => setTimeout(() => {
        if (!tries) onMaxTriesReachWhenWaitingRudderStackToBeReady();
        if (isReady || !tries) resolve();
        else checkIsReady(resolve, tries - 1);
    }, WAIT_FOR_READY_TRIES_TIME);

    return new Promise(resolve => checkIsReady(resolve));
};

const onMaxTriesReachWhenWaitingRudderStackToBeReady = () => {
    captureMessage('Failed waiting Rudder Stack to be ready. This affects the events tracking.', Severity.Error);
};

const track = async ({ payload }) => {
    const {
        event, properties, options, callback,
    } = payload;

    if (!isReady) await waitsRudderStackToBeReady();
    rudderanalytics.track(event, properties, options, callback);
};

const identify = ({ payload }) => {
    const {
        userId, traits, options, callback,
    } = payload;

    rudderanalytics.identify(userId, traits, options, callback);
};

const reset = () => {
    rudderanalytics.reset();
};

const page = () => {
    rudderanalytics.page();
};

const initialize = ({ config }) => {
    const { writeKey, dataPlaneUrl } = config;

    isReady = false;
    rudderanalytics.load(writeKey, dataPlaneUrl);
    rudderanalytics.ready(() => {
        isReady = true;
    });
};

export const createRudderStackPlugin = (options: RudderStackPluginOptions) => ({
    name: 'rudder-stack',
    config: options,
    initialize: initialize.bind(null),
    identify: identify.bind(null),
    track: track.bind(null),
    reset: reset.bind(null),
    page: page.bind(null),

});
